import { Link } from '@ui-components/actions/Link'
import { BankNavigationArrowLeft } from '@ui-components/assets/Icons'
import { Colors } from '@ui-components/global/colors'
import { FlexRowContainer } from '@ui-components/global/CommonStyling'
import { MAIN_STEP_HEADER_HEIGHT } from '@ui-components/global/constants'
import { SPACE_XXSMALL } from '@ui-components/global/spacing'
import { BodyText } from '@ui-components/typography/Typography'
import { IntlShape } from 'react-intl'
import styled from 'styled-components'

interface TheEndTopBarProps {
  onBackConfirmed: () => void
  exit: () => void
  formatMessage: IntlShape['formatMessage']
}

const Container = styled(FlexRowContainer)`
  justify-content: space-between;
  width: 100%;
  height: ${MAIN_STEP_HEADER_HEIGHT}px;
  padding: ${SPACE_XXSMALL};
  position: relative;

  a {
    width: fit-content;
  }
`

const GreenBodyText = styled(BodyText)`
  color: ${Colors.TextStrongPrimary};
`

export const TheEndTopBar = ({ onBackConfirmed, exit, formatMessage }: TheEndTopBarProps) => {
  return (
    <Container as="nav">
      <Link
        standalone={true}
        color="neutral"
        icon={<BankNavigationArrowLeft style={{ color: `${Colors.TextDefaultNeutral}` }} />}
        onClick={onBackConfirmed}
      >
        <BodyText>{formatMessage({ id: 'common-back-to-summary-action' })}</BodyText>
      </Link>
      <Link standalone={true} onClick={exit}>
        <GreenBodyText>{formatMessage({ id: 'common-exit' })}</GreenBodyText>
      </Link>
    </Container>
  )
}
